const getShopifyImageLazyLink = (link) => {
    return link + (link.includes('?v=') ? '&' : '?') + 'width={width}';
};
const getCloudinaryImageLazyLink = (link) => {
    return link.replace(/(\/v\d+\/)/, '/w_{width}$1');
};
const getLazyLinkToImage = (link = '') => {
    return link.includes('cdn.shopify') || link.includes('images.elephantstock.net')
        ? getShopifyImageLazyLink(link.replace(/ /g, '_').replace(/'/g, ''))
        : getCloudinaryImageLazyLink(link);
};
export { getLazyLinkToImage };
